// src/assets/data/vpsData.js
// Single source of truth for Linux variants — every plan and custom builder uses this.
export const LINUX_DISTROS = ["Ubuntu", "Red Hat", "Debian", "Fedora", "Rocky"];
export const vpsData = [
  // VPS Plans
  {
    plan: "Basic",
    cpu: "2 vCPU Core",
    ram: "2 GB",
    storage: "30 GB NVMe",
    type: "vps",
    osOptions: {
      linux: {
        price: "GHS 204",
        distros: [...LINUX_DISTROS],
      },
      windows: {
        price: "GHS 204",
        versions: ["Windows Server 2019", "Windows Server 2022"],
      },
    },
  },
  {
    plan: "Basic Plus",
    cpu: "2 vCPU Cores",
    ram: "4 GB",
    storage: "50 GB NVMe",
    type: "vps",
    osOptions: {
      linux: {
        price: "GHS 276",
        distros: [...LINUX_DISTROS],
      },
      windows: {
        price: "GHS 276",
        versions: ["Windows Server 2019", "Windows Server 2022"],
      },
    },
  },
  {
    plan: "Standard",
    cpu: "4 vCPU Cores",
    ram: "8 GB",
    storage: "100 GB NVMe",
    type: "vps",
    osOptions: {
      linux: {
        price: "GHS 552",
        distros: [...LINUX_DISTROS],
      },
      windows: {
        price: "GHS 552",
        versions: ["Windows Server 2019", "Windows Server 2022"],
      },
    },
  },
  {
    plan: "Standard Plus",
    cpu: "4 vCPU Cores",
    ram: "16 GB",
    storage: "120 GB NVMe",
    type: "vps",
    osOptions: {
      linux: {
        price: "GHS 696",
        distros: [...LINUX_DISTROS],
      },
      windows: {
        price: "GHS 696",
        versions: ["Windows Server 2019", "Windows Server 2022"],
      },
    },
  },
  {
    plan: "Professional",
    cpu: "8 vCPU Cores",
    ram: "12 GB",
    storage: "150 GB NVMe",
    type: "vps",
    osOptions: {
      linux: {
        price: "GHS 936",
        distros: [...LINUX_DISTROS],
      },
      windows: {
        price: "GHS 936",
        versions: ["Windows Server 2019", "Windows Server 2022"],
      },
    },
  },
  {
    plan: "Professional Plus",
    cpu: "8 vCPU Cores",
    ram: "16 GB",
    storage: "200 GB NVMe",
    type: "vps",
    osOptions: {
      linux: {
        price: "GHS 1,104",
        distros: [...LINUX_DISTROS],
      },
      windows: {
        price: "GHS 1,104",
        versions: ["Windows Server 2019", "Windows Server 2022"],
      },
    },
  },
  {
    plan: "Enterprise",
    cpu: "8 vCPU Cores",
    ram: "32 GB",
    storage: "500 GB NVMe",
    type: "vps",
    osOptions: {
      linux: {
        price: "GHS 2,016",
        distros: [...LINUX_DISTROS],
      },
      windows: {
        price: "GHS 2,016",
        versions: ["Windows Server 2019", "Windows Server 2022"],
      },
    },
  },
  {
    plan: "Enterprise Plus",
    cpu: "16 vCPU Cores",
    ram: "64 GB",
    storage: "600 GB NVMe",
    type: "vps",
    osOptions: {
      linux: {
        price: "GHS 3,072",
        distros: [...LINUX_DISTROS],
      },
      windows: {
        price: "GHS 3,072",
        versions: ["Windows Server 2019", "Windows Server 2022"],
      },
    },
  },
  {
    plan: "High Performance",
    cpu: "32 vCPU Cores",
    ram: "128 GB",
    storage: "1 TB NVMe",
    type: "vps",
    osOptions: {
      linux: {
        price: "GHS 3,500",
        distros: [...LINUX_DISTROS],
      },
      windows: {
        price: "GHS 4,200",
        versions: ["Windows Server 2019", "Windows Server 2022"],
      },
    },
  },

  // ============ CLOUD STORAGE PLANS ============
  {
    plan: "Cloud Storage - 1TB",
    cpu: "N/A",
    ram: "N/A",
    storage: "1 TB",
    type: "storage",
    isStorageOnly: true,
    osOptions: {
      storage: {
        price: "GHS 138",
        description: "Pure cloud storage without compute"
      }
    }
  },
  {
    plan: "Cloud Storage - 2TB",
    cpu: "N/A",
    ram: "N/A",
    storage: "2 TB",
    type: "storage",
    isStorageOnly: true,
    osOptions: {
      storage: {
        price: "GHS 262",
        description: "Pure cloud storage without compute"
      }
    }
  },
  {
    plan: "Cloud Storage - 5TB",
    cpu: "N/A",
    ram: "N/A",
    storage: "5 TB",
    type: "storage",
    isStorageOnly: true,
    osOptions: {
      storage: {
        price: "GHS 607",
        description: "Pure cloud storage without compute"
      }
    }
  },
  {
    plan: "Cloud Storage - 10TB",
    cpu: "N/A",
    ram: "N/A",
    storage: "10 TB",
    type: "storage",
    isStorageOnly: true,
    osOptions: {
      storage: {
        price: "GHS 1,104",
        description: "Pure cloud storage without compute"
      }
    }
  },
  {
    plan: "Cloud Storage - 20TB",
    cpu: "N/A",
    ram: "N/A",
    storage: "20 TB",
    type: "storage",
    isStorageOnly: true,
    osOptions: {
      storage: {
        price: "GHS 2,070",
        description: "Pure cloud storage without compute"
      }
    }
  },
  {
    plan: "Cloud Storage - 50TB",
    cpu: "N/A",
    ram: "N/A",
    storage: "50 TB",
    type: "storage",
    isStorageOnly: true,
    osOptions: {
      storage: {
        price: "GHS 4,140",
        description: "Pure cloud storage without compute"
      }
    }
  }
];

export const vpsNotes = {
  additionalStorage: {
    hdd: "GHS 10 per every 50GB SSD",
    NVMe: "GHS 19 per every 50GB NVMe",
  },
  billingCycle: "Annually / Quarterly",
};

export const storagePricing = {
  NVMe: {
    pricePer50GB: 19.00,
    unitSize: 50,
  },
  HDD: {
    pricePer50GB: 10.00,
    unitSize: 50,
  },
};